import * as types from '../../../../store/mutation-types';
import Sidebar from './sidebar';

export default {
  props: ['foundation', 'activeProject'],
  components: {
    'sidebar': Sidebar,
  },
  computed: {
    opened() {
      return this.$store.state.ui.mobileSidebarOpened;
    },
    projectInfoOpened() {
      return this.$store.state.ui.mobileProjectInfoOpened;
    },
    projectGroupsWithProjects() {
      return this.$store.getters.projectGroupsWithProjects;
    },
    projectsNotInAGroupAsArray() {
      return this.$store.getters.projectsNotInAGroupAsArray;
    },
  },
  methods: {
    toggleProjectInfo(val) {
      this.$store.commit(types.TOGGLE_MOBILE_PROJECT_INFO, val);
    },
    closeSidebar() {
      this.$store.commit(types.TOGGLE_MOBILE_SIDEBAR, false);
    },
    setActiveProject(projectId) {
      this.$store.commit(types.SET_ACTIVE_PROJECT_ID, projectId);
    },
    toggle(group) {
      this.$store.dispatch('toggleProjectGroup', group.id);
    },
  },
};
